import React, { useState, useEffect, useContext } from 'react';
import '../../../assests/css/admin/AdminSetting.css';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import axios from 'axios';
import { AppContext } from '../../../context/Appcontext';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from 'react-bootstrap';

const AdminSettings = () => {
  const { baseUrl } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState('general');

  // ── General Info States ──
  const [collegeName, setCollegeName] = useState('');
  const [collegeEmail, setCollegeEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  // ── Notification States ──
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [smsNotifications, setSmsNotifications] = useState(false);

  // ── Security States ──
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // ── Profile States ──
  const [profileFullName, setProfileFullName] = useState('');
  const [profileEmail, setProfileEmail] = useState('');
  const [profilePhone, setProfilePhone] = useState('');
  const [profileExists, setProfileExists] = useState(false);

  // ── Loading States ──
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  // ── Static Activity Data ──
  // const activities = [
  //   { id: 1, field: 'Exam Schedule Updated', date: 'May 15, 2025', status: 'active' },
  //   { id: 2, field: 'New Student Enrolled', date: 'May 13, 2025', status: 'done' },
  //   { id: 3, field: 'Fee Report Generated', date: 'May 10, 2025', status: 'done' },
  //   { id: 4, field: 'Course Approval Pending', date: 'May 08, 2025', status: 'pending' },
  //   { id: 5, field: 'Faculty Meeting Scheduled', date: 'May 06, 2025', status: 'active' },
  // ];

  // ── Profile Stats ──
  // const totalCourses = 24;
  // const totalStudents = 1840;
  // const yearsActive = 15;

  const tabs = [
    { id: 'profile', label: 'Profile', icon: '👤' },
    { id: 'general', label: 'General Info', icon: '🎓' },
    { id: 'notifications', label: 'Notifications', icon: '🔔' },
    // { id: 'security', label: 'Security', icon: '🔒' },
  ];

  const getStatusClass = (status) => {
    if (status === 'active') return 'cas-profile__status-badge cas-profile__status-badge--active';
    if (status === 'pending') return 'cas-profile__status-badge cas-profile__status-badge--pending';
    return 'cas-profile__status-badge cas-profile__status-badge--done';
  };

  const getStatusLabel = (status) => {
    if (status === 'active') return '🟢 Active';
    if (status === 'pending') return '🟠 Pending';
    return '✅ Done';
  };
  // ── VIEW GENERAL INFO ──
  const loadGeneralInfo = () => {
    axios
      .get(`${baseUrl}/admin/general-info`)
      .then((response) => {
        console.log("General Info:", response.data);

        if (response.data.success && response.data.info) {
          setCollegeName(response.data.info.collegeName || '');
          setCollegeEmail(response.data.info.collegeEmail || '');
          setPhoneNumber(response.data.info.phoneNumber || '');
        }
      })
      .catch((error) => {
        console.error("Failed to load General Info:", error);
      });
  };
  // ── VIEW NOTIFICATION SETTINGS ──
  const loadNotificationSettings = () => {
    axios
      .get(`${baseUrl}/admin/notification-settings`)
      .then((response) => {
        console.log("Notification Settings:", response.data);

        if (response.data.success && response.data.settings) {
          setEmailNotifications(
            response.data.settings.emailNotifications === true ||
            response.data.settings.emailNotifications === 1
          );

          setSmsNotifications(
            response.data.settings.smsNotifications === true ||
            response.data.settings.smsNotifications === 1
          );
        }
      })
      .catch((error) => {
        console.error("Failed to load Notification Settings:", error);
      });
  };

  // ── SAVE NOTIFICATION SETTINGS ──
  const saveNotificationSettings = () => {
    const data = {
      emailNotifications: emailNotifications,
      smsNotifications: smsNotifications
    };

    setIsSubmitting(true);

    axios
      .post(`${baseUrl}/admin/notification-settings`, data)
      .then((response) => {
        console.log("Save Notification Settings:", response.data);

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Saved Successfully!",
            text: "Notification preferences have been updated.",
            confirmButtonText: "Okay"
          });
        }
      })
      .catch((error) => {
        console.error("Notification Settings Error:", error);
        console.error("Response:", error.response);
        console.error("Response Data:", error.response?.data);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Failed to save notification preferences."
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  // ── SAVE GENERAL INFO ──
  const saveGeneralInfo = () => {

    if (!collegeName || !collegeEmail || !phoneNumber) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please fill all General Information fields."
      });
      return;
    }

    const data = {
      collegeName: collegeName,
      collegeEmail: collegeEmail,
      phoneNumber: phoneNumber
    };

    setIsSubmitting(true);

    axios
      .post(`${baseUrl}/admin/general-info`, data)
      .then((response) => {
        console.log("Save General Info:", response.data);

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Saved Successfully!",
            text: "General information has been updated.",
            confirmButtonText: "Okay"
          });
        }
      })
      .catch((error) => {
        console.error("General Info Error:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to save general information."
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const viewProfile = () => {
    setIsFetching(true);

    const savedAdmin = JSON.parse(localStorage.getItem("admin"));

    console.log("Logged in admin:", savedAdmin);

    if (savedAdmin) {
      setProfileFullName(
        `${savedAdmin.firstName || ''} ${savedAdmin.lastName || ''}`.trim()
      );

      setProfileEmail(savedAdmin.email || '');
      setProfilePhone(savedAdmin.phone || '');

      setProfileExists(true);
    } else {
      setProfileExists(false);
    }

    setIsFetching(false);
  };

  useEffect(() => {
    viewProfile();
    loadGeneralInfo();
    loadNotificationSettings();
  }, []);

  // ── CREATE profile ──
  const createProfile = () => {
    const formdata = new FormData();
    formdata.append('firstName', profileFullName);
    formdata.append('lastName', profileFullName);
    formdata.append('email', profileEmail);
    formdata.append('phone', profilePhone);

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/adminprofile`, formdata, { withCredentials: true })
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setProfileExists(true);
          Swal.fire({ icon: 'success', title: 'Profile Created!', confirmButtonText: 'Okay' });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to create profile.' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  // ── UPDATE profile ──
  const updateProfile = () => {
    const formdata = new FormData();
    const savedAdmin = JSON.parse(localStorage.getItem("admin"));
    formdata.append("admin_id", savedAdmin.id);
    formdata.append('firstName', profileFullName);
    formdata.append('lastName', profileFullName);
    formdata.append('email', profileEmail);
    formdata.append('phone', profilePhone);

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/update-adminprofile`, formdata, { withCredentials: true })
      .then((response) => {
        console.log(response.data);
        Swal.fire({ icon: 'success', title: 'Profile Updated!', confirmButtonText: 'Okay' });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to update profile.' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  // ── DELETE profile ──
  const deleteProfile = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete your profile.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (!result.isConfirmed) return;

      setIsDeleting(true);
      axios
        .delete(`${baseUrl}/admin/delete-adminprofile`, { withCredentials: true })
        .then((response) => {
          console.log(response.data);
          setProfileFullName('');
          setProfileEmail('');
          setProfilePhone('');
          setProfileExists(false);
          Swal.fire({ icon: 'success', title: 'Deleted!', confirmButtonText: 'Okay' });
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to delete profile.' });
        })
        .finally(() => {
          setIsDeleting(false);
        });
    });
  };

  // ── Save button: create or update ──
  const handleSaveProfile = () => {
    if (!profileFullName || !profileEmail) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter your name and email."
      });
      return;
    }

    updateProfile();
  };

  return (
    <Adminmasterlayout>
      <div className="cas-wrapper">
        <div className="cas-container">

          {/* ── Header ── */}
          <header className="cas-header">
            <div className="cas-header__brand">
              <div className="cas-header__logo">🎓</div>
              <div>
                <h1 className="cas-header__title">College Administration</h1>
                <p className="cas-header__subtitle">
                  Manage your institution's settings and configurations
                </p>
              </div>
            </div>
          </header>

          {/* ── Main Grid ── */}
          <div className="cas-grid">

            {/* Sidebar */}
            <aside className="cas-sidebar">
              <nav className="cas-nav">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`cas-nav__item ${activeTab === tab.id ? 'cas-nav__item--active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <span className="cas-nav__icon">{tab.icon}</span>
                    <span className="cas-nav__label">{tab.label}</span>
                  </button>
                ))}
              </nav>
            </aside>

            {/* Content Panel */}
            <main className="cas-content">

              {/* ══ PROFILE ══ */}
              {activeTab === 'profile' && (
                <div className="cas-section">
                  <div className="cas-section__header">
                    <h2 className="cas-section__title">👤 Profile Settings</h2>
                    <p className="cas-section__desc">
                      Manage your personal information and activity overview.
                    </p>
                  </div>

                  {isFetching ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                      <Spinner animation="border" />
                    </div>
                  ) : (
                    <>
                      {/* Avatar & Name Row */}
                      <div className="cas-profile__top">
                        <div className="cas-profile__avatar-wrap">
                          <div className="cas-profile__avatar">👤</div>
                          <div className="cas-profile__avatar-badge">✏️</div>
                        </div>
                        <div className="cas-profile__avatar-info">
                          <div className="cas-profile__name">{profileFullName || 'No Name Set'}</div>
                          {/* <button className="cas-profile__upload-btn">📷 Change Photo</button> */}
                        </div>
                      </div>

                      {/* Stats */}
                      {/* <div className="cas-profile__stats">
                        <div className="cas-profile__stat-card">
                          <div className="cas-profile__stat-icon">📚</div>
                          <div className="cas-profile__stat-value">{totalCourses}</div>
                          <div className="cas-profile__stat-label">Courses</div>
                        </div>
                        <div className="cas-profile__stat-card">
                          <div className="cas-profile__stat-icon">🎓</div>
                          <div className="cas-profile__stat-value">{totalStudents.toLocaleString()}</div>
                          <div className="cas-profile__stat-label">Students</div>
                        </div>
                        <div className="cas-profile__stat-card">
                          <div className="cas-profile__stat-icon">⭐</div>
                          <div className="cas-profile__stat-value">{yearsActive}+</div>
                          <div className="cas-profile__stat-label">Years Active</div>
                        </div>
                      </div> */}

                      {/* Profile Form */}
                      <div className="cas-form__grid">
                        <div className="cas-form__group">
                          <label className="cas-form__label">Full Name</label>
                          <input
                            type="text"
                            value={profileFullName}
                            onChange={(e) => setProfileFullName(e.target.value)}
                            className="cas-form__input"
                            placeholder="Enter your full name"
                          />
                        </div>

                        <div className="cas-form__group">
                          <label className="cas-form__label">Email Address</label>
                          <input
                            type="email"
                            value={profileEmail}
                            onChange={(e) => setProfileEmail(e.target.value)}
                            className="cas-form__input"
                            placeholder="Enter your email"
                          />
                        </div>

                        <div className="cas-form__group">
                          <label className="cas-form__label">Phone Number</label>
                          <input
                            type="tel"
                            value={profilePhone}
                            onChange={(e) => setProfilePhone(e.target.value)}
                            className="cas-form__input"
                            placeholder="+1 (555) 000-0000"
                          />
                        </div>
                      </div>

                      {/* Activity Table */}
                      <div className="cas-profile__table-wrap">
                        {/* <div className="cas-profile__table-header">
                          <div className="cas-profile__table-title">📋 Recent Activity</div>
                          <div className="cas-profile__filters">
                            <input
                              type="text"
                              className="cas-profile__filter-input"
                              placeholder="🔍 Search activity..."
                              readOnly
                            />
                            <button className="cas-profile__filter-btn cas-profile__filter-btn--active">All</button>
                            <button className="cas-profile__filter-btn">Active</button>
                            <button className="cas-profile__filter-btn">Pending</button>
                            <button className="cas-profile__filter-btn">Done</button>
                          </div>
                        </div> */}

                        {/* <table className="cas-profile__table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Activity</th>
                              <th>Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activities.map((a) => (
                              <tr key={a.id}>
                                <td>{a.id}</td>
                                <td>{a.field}</td>
                                <td>{a.date}</td>
                                <td>
                                  <span className={getStatusClass(a.status)}>
                                    {getStatusLabel(a.status)}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table> */}
                      </div>

                      {/* Actions */}
                      <div className="cas-form__actions">
                        {isSubmitting ? (
                          <Spinner animation="border" />
                        ) : (
                          <button
                            className="cas-btn cas-btn--primary"
                            onClick={handleSaveProfile}
                            disabled={isSubmitting}
                          >
                            💾 Update Profile
                          </button>
                        )}

                        {profileExists && (
                          isDeleting ? (
                            <Spinner animation="border" style={{ marginLeft: '12px' }} />
                          ) : (
                            <button
                              className="cas-btn"
                              onClick={deleteProfile}
                              disabled={isDeleting}
                              style={{
                                marginLeft: '12px',
                                backgroundColor: '#ef4444',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '10px 20px',
                                cursor: 'pointer',
                              }}
                            >
                              🗑️ Delete Profile
                            </button>
                          )
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* ══ GENERAL INFO ══ */}
              {activeTab === 'general' && (
                <div className="cas-section">
                  <div className="cas-section__header">
                    <h2 className="cas-section__title">🏫 General Information</h2>
                    <p className="cas-section__desc">
                      Update your college's basic contact details.
                    </p>
                  </div>

                  <div className="cas-form__grid">
                    <div className="cas-form__group">
                      <label className="cas-form__label">College Name</label>
                      <input
                        type="text"
                        value={collegeName}
                        onChange={(e) => setCollegeName(e.target.value)}
                        className="cas-form__input"
                        placeholder="Enter college name"
                      />
                    </div>

                    <div className="cas-form__group">
                      <label className="cas-form__label">Email Address</label>
                      <input
                        type="email"
                        value={collegeEmail}
                        onChange={(e) => setCollegeEmail(e.target.value)}
                        className="cas-form__input"
                        placeholder="admin@college.edu"
                      />
                    </div>

                    <div className="cas-form__group">
                      <label className="cas-form__label">Phone Number</label>
                      <input
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        className="cas-form__input"
                        placeholder="+1 (555) 000-0000"
                      />
                    </div>
                  </div>

                  <div className="cas-form__actions">
                    <button
                      className="cas-btn cas-btn--primary"
                      onClick={saveGeneralInfo}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "💾 Save Changes"
                      )}
                    </button>
                  </div>
                </div>
              )}

              {/* ══ NOTIFICATIONS ══ */}
              {activeTab === 'notifications' && (
                <div className="cas-section">
                  <div className="cas-section__header">
                    <h2 className="cas-section__title">🔔 Notification Settings</h2>
                    <p className="cas-section__desc">
                      Choose how you receive system alerts and updates.
                    </p>
                  </div>

                  <div className="cas-toggle__list">
                    <div className="cas-toggle__item">
                      <div className="cas-toggle__icon">📧</div>
                      <div className="cas-toggle__info">
                        <h3 className="cas-toggle__title">Email Notifications</h3>
                        <p className="cas-toggle__desc">
                          Receive important alerts and updates via email.
                        </p>
                      </div>
                      <label className="cas-toggle">
                        <input
                          type="checkbox"
                          checked={emailNotifications}
                          onChange={(e) => setEmailNotifications(e.target.checked)}
                        />
                        <span className="cas-toggle__slider" />
                      </label>
                    </div>

                    <div className="cas-toggle__item">
                      <div className="cas-toggle__icon">📱</div>
                      <div className="cas-toggle__info">
                        <h3 className="cas-toggle__title">SMS Notifications</h3>
                        <p className="cas-toggle__desc">
                          Receive critical alerts directly to your mobile phone.
                        </p>
                      </div>
                      <label className="cas-toggle">
                        <input
                          type="checkbox"
                          checked={smsNotifications}
                          onChange={(e) => setSmsNotifications(e.target.checked)}
                        />
                        <span className="cas-toggle__slider" />
                      </label>
                    </div>
                  </div>

                  <div className="cas-form__actions">
                    <button
                      className="cas-btn cas-btn--primary"
                      onClick={saveNotificationSettings}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "💾 Save Preferences"
                      )}
                    </button>
                  </div>
                </div>
              )}

              {/* ══ SECURITY ══ */}
              {activeTab === 'security' && (
                <div className="cas-section">
                  <div className="cas-section__header">
                    <h2 className="cas-section__title">🔒 Security</h2>
                    <p className="cas-section__desc">
                      Update your admin password to keep your account secure.
                    </p>
                  </div>

                  <div className="cas-password__card">
                    <div className="cas-password__icon">🔑</div>
                    <h3 className="cas-password__heading">Reset Password</h3>
                    <p className="cas-password__sub">
                      Choose a strong password with at least 8 characters.
                    </p>

                    <div className="cas-form__grid cas-form__grid--single">
                      <div className="cas-form__group">
                        <label className="cas-form__label">Current Password</label>
                        <input
                          type="password"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                          className="cas-form__input"
                          placeholder="Enter current password"
                        />
                      </div>

                      <div className="cas-form__group">
                        <label className="cas-form__label">New Password</label>
                        <input
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="cas-form__input"
                          placeholder="Enter new password"
                        />
                      </div>

                      <div className="cas-form__group">
                        <label className="cas-form__label">Confirm New Password</label>
                        <input
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="cas-form__input"
                          placeholder="Re-enter new password"
                        />
                      </div>
                    </div>

                    <div className="cas-form__actions">
                      <button className="cas-btn cas-btn--primary">
                        🔑 Update Password
                      </button>
                    </div>
                  </div>
                </div>
              )}

            </main>
          </div>
        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default AdminSettings;